import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantPreviousResidencePage = {
  alert: {
    error: 'coapplicant-previous-residence.alert.error',
  },
  footer: {
    root: 'coapplicant-previous-residence.footer.root',
  },
  form: {
    addressLine1Input:
      'coapplicant-previous-residence.form.address-line-1-input',
    addressLine1InputError:
      'coapplicant-previous-residence.form.address-line-1-input-error',
    addressLine2Input:
      'coapplicant-previous-residence.form.address-line-2-input',
    cityInput: 'coapplicant-previous-residence.form.city-input',
    cityInputError: 'coapplicant-previous-residence.form.city-input-error',
    h1: 'coapplicant-previous-residence.form.h1',
    h2: 'coapplicant-previous-residence.form.h2',
    root: 'coapplicant-previous-residence.form.root',
    stateSelect: 'coapplicant-previous-residence.form.state-select',
    stateSelectError: 'coapplicant-previous-residence.form.state-select-error',
    submitButton: 'coapplicant-previous-residence.form.submit-button',
    zipCodeInput: 'coapplicant-previous-residence.form.zip-code-input',
    zipCodeInputError:
      'coapplicant-previous-residence.form.zip-code-input-error',
  },
  header: {
    drawerButton: 'coapplicant-previous-residence.header.drawer-button',
    previousStepButton:
      'coapplicant-previous-residence.header.previous-step-button',
    root: 'coapplicant-previous-residence.header.root',
  },
  progress: {
    root: 'coapplicant-previous-residence.progress.root',
  },
} as const satisfies PageLocatorMap;
